import React from "react";
import { useNavigate } from "react-router-dom";

export default function GovLogin() {
  const nav = useNavigate();
  function fakeSignIn() {
    sessionStorage.setItem("enterprise_authed", "1");
    sessionStorage.setItem("enterprise_org", "gov-synktribe");
    nav("/enterprise", { replace: true });
  }

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-[#0b0f14] via-[#0b0e12] to-black text-white">
      <div className="w-full max-w-md rounded-2xl border border-yellow-300/20 bg-[#0b0f14]/60 p-6 shadow-[0_0_40px_rgba(255,215,0,0.05)]">
        <div className="text-lg font-semibold mb-1">SynkTribe Gov Access</div>
        <div className="text-xs opacity-80 mb-4">
          FIPS-aligned surface. Strong CSP/HSTS, separate cookies, sovereign region routing.
        </div>
        <div className="grid gap-3">
          <button
            onClick={fakeSignIn}
            className="px-3 py-2 rounded-xl border border-yellow-300/30 bg-yellow-300/10 hover:bg-yellow-300/15 text-sm"
          >
            Continue with Gov SSO (demo)
          </button>
        </div>
        <div className="text-xs opacity-60 mt-4">
          Bind to a dedicated SAML provider + redirect URI on <span className="font-mono">gov.synktribe.*</span>.
        </div>
      </div>
    </div>
  );
}
